import type { WorkspaceAction } from './workspacePermissions'
import type { ChatCommandAction, ChatCommandType } from '../types/chat'
import { executeChatCommand } from '../services/commandExecutionService'

type DeltaBinding = {
  permission: WorkspaceAction
  fallbackSummary: (command: ChatCommandAction) => string
}

export const CHAT_COMMAND_EXECUTION_MAP: Record<ChatCommandType, DeltaBinding> = {
  TIMELINE_MOVE: {
    permission: 'timeline.edit',
    fallbackSummary: (command) => `Shift timeline item by ${'deltaDays' in command.payload ? command.payload.deltaDays : 0} day(s)`,
  },
  CHECKLIST_STATUS: {
    permission: 'checklist.change_status',
    fallbackSummary: (command) => `Change checklist status to ${'status' in command.payload ? command.payload.status : 'the requested state'}`,
  },
  TASK_CREATE: {
    permission: 'timeline.create',
    fallbackSummary: (command) => `Create task ${'title' in command.payload ? command.payload.title : ''}`.trim(),
  },
  DECISION_LOG: {
    permission: 'chat.send',
    fallbackSummary: (command) => `Log decision ${'text' in command.payload ? command.payload.text : ''}`.trim(),
  },
  BLOCKER_LOG: {
    permission: 'chat.send',
    fallbackSummary: (command) => `Log blocker ${'text' in command.payload ? command.payload.text : ''}`.trim(),
  },
  FOLLOW_UP_LOG: {
    permission: 'chat.send',
    fallbackSummary: (command) => `Log follow-up ${'text' in command.payload ? command.payload.text : ''}`.trim(),
  },
}

export const getChatCommandSummary = (command: ChatCommandAction) =>
  command.summary.trim() || CHAT_COMMAND_EXECUTION_MAP[command.type].fallbackSummary(command)

export const processChatCommand = async (
  command: ChatCommandAction,
  canPerform: (action: WorkspaceAction) => boolean,
) => {
  const binding = CHAT_COMMAND_EXECUTION_MAP[command.type]
  if (!canPerform(binding.permission)) throw new Error(`Workspace permission ${binding.permission} is required.`)
  if (command.status !== 'PENDING') throw new Error(`Command is already ${command.status.toLowerCase()}.`)
  return executeChatCommand(command)
}
